import { useEffect, useMemo } from 'react';
import { useLazyService } from '@atlassian/teams-common/use-service';
import { defaultRequestAbort } from './utils';
export const useLazyJiraCheckService = (cloudId, options) => {
  var _result$data;
  const [request, controller] = useMemo(() => defaultRequestAbort(cloudId), [cloudId]);
  const [getJiraCheck, result] = useLazyService(request, controller, {
    initialState: {
      ...(options === null || options === void 0 ? void 0 : options.initialState)
    }
  });
  return [getJiraCheck, {
    ...result,
    isJiraAvailable: Boolean((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.permitted)
  }];
};
export const useJiraCheckService = (...[cloudId, options]) => {
  const [getJiraCheck, result] = useLazyJiraCheckService(cloudId, options);
  useEffect(() => {
    if (cloudId) {
      getJiraCheck();
    }
  }, [cloudId, getJiraCheck]);
  return result;
};